import { isValidNumber as isValidNumberString } from './string/isValidNumber';

/**
 * Valida si una cadena es un numero valido.
 * Para validar un tipo 'number', usar isNumber()
 *
 * @param {string, number}
 *
 * @return {boolean}
 */
export function isValidNumber(str = '') {
  return isValidNumberString(`${str}`);
}
